<template>
  <v-container>
    <v-row align-content="space-between">
      <v-col v-for="(video,index) in list" :key="index" cols="6" xl="1" lg="2" md="2" sm="3">
        <div>
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 15 : 3">
              <v-img :src="video.vodPic ? video.vodPic : errorImg"
                     height="180"
                     :lazy-src="lazyImg"
                     class="white--text align-end img-class"
                     gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                <v-card-title class="text-subtitle-2">
                  <div class="text-no-wrap text-truncate">
                    {{ video.vodRemarks }}
                  </div>
                </v-card-title>
              </v-img>

              <v-card-text>
                <div class="mt-1 text-center text-no-wrap text-truncate">
                  {{ video.vodName }}
                </div>
              </v-card-text>

              <v-fade-transition>
                <v-overlay
                    v-if="hover"
                    absolute
                    z-index="2"
                    opacity="1">
                  <div>
                    <v-btn @click="toPlayer(video)">立即播放</v-btn>
                  </div>
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </v-hover>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VideoList",
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    size: undefined,
    errorImg: require('@/assets/error-loading.gif'),
    lazyImg: require('@/assets/winter-img-loading.gif'),
  }),
  methods: {
    toPlayer({id}) {
      this.$router.push({
        path: '/video/info',
        query: {id: id}
      })
    },
  },

}
</script>

<style scoped>
</style>
